export class AdminLoginCredentials {
  private constructor(
    readonly email: string,
    readonly password: string,
  ) {}

  static init() {
    return new AdminLoginCredentials('', '');
  }
}
